export default __webpack_public_path__ + "static/media/con-pvr-legend-county.bb26b29e.png";